/* ============================================================================
 * gk-motion.js — page-wide scroll motion for the Gaming Keyboards collection.
 * ----------------------------------------------------------------------------
 * Gives cohesive "flow" to EVERY section, including the ones we reuse as-is
 * (comparison table, product grid, series, accessories, reviews):
 *   1. Blur-reveal for any [data-gk-reveal] block (gk-tech / gk-cta heads+rows).
 *   2. Staggered blur-reveal for the product grid cards (.m-product-item).
 *   3. Gentle parallax on big feature images that sit inside a clipped frame
 *      (skips the gk-hero, which runs its own motion, and skips product thumbs).
 *
 * Rules (Emil + directives):
 *   - GSAP core is global (bh-header); ScrollTrigger is self-hosted and loaded
 *     by the gk-* sections. jsdelivr is blocked in mainland China.
 *   - Hidden states are set with GSAP ONLY after it is confirmed loaded, so if
 *     GSAP/ScrollTrigger never arrive the page is fully intact (nothing hidden).
 *   - prefers-reduced-motion → no motion at all (page renders complete).
 *   - Only transform / opacity / filter are animated.
 * ========================================================================== */
(function () {
  if (window.__gkMotion) return;
  window.__gkMotion = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(cb, tries) {
    tries = tries == null ? 80 : tries;
    if (window.gsap && window.ScrollTrigger) return cb(window.gsap, window.ScrollTrigger);
    if (tries <= 0) return;
    requestAnimationFrame(function () { ready(cb, tries - 1); });
  }

  function clips(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.overflow === 'hidden' || cs.overflow === 'clip' ||
           cs.overflowY === 'hidden' || cs.overflowX === 'hidden';
  }

  function start(gsap, ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var FOLD = vh * 0.88;

    /* ---- 1. Blur-reveal for tagged blocks -------------------------------- */
    try {
      var reveals = [].slice.call(document.querySelectorAll('[data-gk-reveal]'));
      var below = reveals.filter(function (el) { return el.getBoundingClientRect().top > FOLD; });
      gsap.set(below, { opacity: 0, y: 26, filter: 'blur(8px)' });
      if (below.length) {
        ScrollTrigger.batch(below, {
          start: 'top 88%', once: true,
          onEnter: function (els) {
            gsap.to(els, {
              opacity: 1, y: 0, filter: 'blur(0px)',
              duration: 0.7, ease: 'power3.out', stagger: 0.09, overwrite: true,
              onComplete: function () { gsap.set(els, { clearProps: 'filter' }); }
            });
          }
        });
      }
    } catch (e) {}

    /* ---- 2. Product grid card stagger ------------------------------------ */
    try {
      var cards = [].slice.call(document.querySelectorAll('.m-product-item'));
      var cBelow = cards.filter(function (el) { return el.getBoundingClientRect().top > FOLD; });
      gsap.set(cBelow, { opacity: 0, y: 30, filter: 'blur(6px)' });
      if (cBelow.length) {
        ScrollTrigger.batch(cBelow, {
          start: 'top 94%', once: true,
          onEnter: function (els) {
            gsap.to(els, {
              opacity: 1, y: 0, filter: 'blur(0px)',
              duration: 0.6, ease: 'power3.out', stagger: 0.07, overwrite: true,
              onComplete: function () { gsap.set(els, { clearProps: 'filter' }); }
            });
          }
        });
      }
    } catch (e) {}

    /* ---- 3. Parallax on big feature images (skip hero + product thumbs) -- */
    try {
      var media = [].slice.call(document.querySelectorAll(
        '.shopify-section img, .shopify-section picture, .shopify-section video'
      ));
      media.forEach(function (m) {
        if (m.closest('.m-gkh, .m-gkt, [data-gk-hero]')) return;   // gk sections run their own motion
        if (m.closest('.m-product-item')) return;                  // cards animate via #2
        var r = m.getBoundingClientRect();
        if (r.height < 220 || r.width < 260) return;               // skip icons / thumbs
        if (!clips(m.parentElement)) return;                       // only inside a clipped frame
        if (getComputedStyle(m).animationName !== 'none') return;  // leave self-animating media
        gsap.set(m, { scale: 1.12, transformOrigin: '50% 50%', willChange: 'transform' });
        gsap.fromTo(m, { yPercent: -6 }, {
          yPercent: 6, ease: 'none',
          scrollTrigger: { trigger: m.parentElement, start: 'top bottom', end: 'bottom top', scrub: 0.5 }
        });
      });
    } catch (e) {}

    requestAnimationFrame(function () { ScrollTrigger.refresh(); });
  }

  if (REDUCED) return;        // leave the page in its complete, static state
  ready(start);
})();
